// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1e4cs","row":"Node_row__6nZ7w","label":"Node_label__2C-So","footer":"Node_footer__IDgY7"};